// vc-cartbox.js — Cart box controller
// Re-renders drawer and handles qty/remove via AJAX
// Initial visibility set by Liquid (body.cartbox-visible class)
// JS updates visibility after cart changes

(function () {
  'use strict';
  
  if (window.__VC_CARTBOX_BOUND__) return;
  window.__VC_CARTBOX_BOUND__ = true;

  var DESKTOP_MIN = 1025;
  var LOG = false;
  var log = function() { if (LOG) console.log.apply(console, ['[vc-cartbox]'].concat(Array.prototype.slice.call(arguments))); };

  // DOM helpers - find the visible section (not the hidden template one)
  function root() { 
    var sections = document.querySelectorAll('[data-section-type="vc-cartbox"]');
    if (sections.length === 1) return sections[0];
    
    // If multiple sections, find the one that's visible or has simpler ID
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      // Prefer section without 'template--' prefix (that's the actual rendered one)
      if (s.dataset.sectionId && s.dataset.sectionId.indexOf('template--') === -1) {
        return s;
      }
    }
    
    // Fallback to last section (usually the rendered one comes after template)
    return sections[sections.length - 1];
  }
  function secId() { var r = root(); return r ? r.dataset.sectionId : null; }

  /* =========================
     Visibility Control
     Only called AFTER cart changes, not on initial load
     ========================= */
  function updateVisibility(cart) {
    var isDesktop = window.innerWidth >= DESKTOP_MIN;
    
    // Check if cartbox element exists (only on home/product pages)
    var cartbox = document.getElementById('vc-cartbox');
    if (!cartbox) {
      document.body.classList.remove('cartbox-visible');
      return;
    }
    
    if (!isDesktop) {
      // On mobile/tablet, always hide cartbox via CSS, but keep class for when returning to desktop
      return;
    }
    
    // Update visibility based on cart count
    var hasItems = cart && cart.item_count > 0;
    document.body.classList.toggle('cartbox-visible', hasItems);
    log(hasItems ? 'Visible: cart has items' : 'Hidden: cart empty');
  }

  /* =========================
     Section re-render
     ========================= */
  function refreshCartbox() {
    var id = secId();
    if (!id) return Promise.resolve();

    // Add timestamp to prevent caching
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id) + '&_=' + Date.now();
    
    log('Fetching cartbox from:', url);
    
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Target element inside our section wrapper
        var sectionWrapper = document.querySelector('[data-section-type="vc-cartbox"][data-section-id="' + id + '"]');
        var updated = tmp.querySelector('#vc-cartbox');
        var current = sectionWrapper ? sectionWrapper.querySelector('#vc-cartbox') : null;

        log('Updated element found:', !!updated);
        log('Current element found:', !!current);

        if (updated && current) {
          current.replaceWith(updated);
          bindCartChangeHandlers();

          // Update saved count if function exists
          if (typeof window.VC_renderSavedList === 'function') {
            window.VC_renderSavedList();
          }
          
          log('Cartbox replaced successfully');
        }
      })
      .catch(function(e) {
        console.warn('[vc-cartbox] refresh failed', e);
      });
  }

  /* =========================
     Qty / Remove forms (AJAX)
     ========================= */
  function handleChangeSubmit(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var submitter = e.submitter;
    
    // Check if submitter is disabled (at max or min)
    if (submitter && submitter.disabled) {
      log('Button disabled, ignoring submit');
      return;
    }

    var fd;
    try {
      fd = new FormData(form, submitter);
    } catch (err) {
      fd = new FormData(form);
    }

    var line = String(fd.get('line') || '');
    var quantity = '';

    if (submitter && submitter.name === 'quantity') {
      quantity = String(submitter.value);
    } else {
      quantity = String(fd.get('quantity') || '');
    }
    
    // Check max quantity
    var maxQty = parseInt(form.dataset.maxQty || '99999', 10);
    var qtyNum = parseInt(quantity, 10);
    
    if (qtyNum > maxQty) {
      log('Quantity exceeds max:', qtyNum, '>', maxQty);
      quantity = String(maxQty);
    }

    var body = 'line=' + encodeURIComponent(line) + '&quantity=' + encodeURIComponent(quantity);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      credentials: 'same-origin',
      body: body,
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        return refreshCartbox().then(function() {
          return cart;
        });
      })
      .then(function(cart) {
        refreshCartUI(cart);
        updateVisibility(cart);
        document.dispatchEvent(new CustomEvent('vc:cart:updated', { detail: cart }));
      })
      .catch(function(err) {
        console.error('[vc-cartbox] change error', err);
      });
  }

  // Refresh header cart badge and update visibility
  function refreshCartUI(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

    var selectors = ['[data-cart-count]', '#cart-count', '.cart-count', '.header-cart-count', '.cart-badge'];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.textContent = String(count);
        if (el.hasAttribute('hidden')) {
          if (count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        }
      });
    });

    // Dispatch event for other scripts
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function bindCartChangeHandlers() {
    document
      .querySelectorAll('#vc-cartbox [data-vc-cart-change]')
      .forEach(function(form) {
        form.removeEventListener('submit', handleChangeSubmit);
        form.addEventListener('submit', handleChangeSubmit);
      });
  }

  /* =========================
     Stock Notification
     ========================= */
  function showStockNotification(message) {
    var notification = document.getElementById('vc-stock-notification');
    if (!notification) {
      notification = document.createElement('div');
      notification.id = 'vc-stock-notification';
      notification.style.cssText = 
        'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); ' +
        'background: #333; color: #fff; padding: 12px 24px; border-radius: 8px; ' +
        'z-index: 10000; font-size: 14px; box-shadow: 0 4px 12px rgba(0,0,0,0.3); ' +
        'transition: opacity 0.3s ease;';
      document.body.appendChild(notification);
    }
    
    notification.textContent = message;
    notification.style.opacity = '1';
    
    setTimeout(function() {
      notification.style.opacity = '0';
    }, 4000);
  }

  /* =========================
     Check and Handle Out of Stock / Over Stock Items
     ========================= */
  function checkAndHandleStockIssues() {
    var cartbox = document.getElementById('vc-cartbox');
    if (!cartbox) return Promise.resolve();
    
    var rows = cartbox.querySelectorAll('.vc-cartbox__row[data-max-qty]');
    var itemsToMove = [];
    var itemsToReduce = [];
    
    rows.forEach(function(row) {
      var maxQty = parseInt(row.dataset.maxQty || '99999', 10);
      var line = row.dataset.line;
      var qtyInput = row.querySelector('.vc-cartbox__qty');
      var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      
      var titleEl = row.querySelector('.vc-cartbox__title');
      var imageEl = row.querySelector('.vc-cartbox__img img');
      var variantEl = row.querySelector('.vc-cartbox__variant');
      var priceEl = row.querySelector('.vc-cartbox__price');
      var saveBtn = row.querySelector('[data-vc-save-for-later]');
      
      var itemData = {
        variantId: saveBtn ? saveBtn.dataset.variantId : '',
        line: line,
        title: titleEl ? titleEl.textContent.trim() : '',
        url: titleEl ? titleEl.getAttribute('href') : '',
        image: imageEl ? imageEl.src : (saveBtn ? saveBtn.dataset.image : ''),
        variant_title: variantEl ? variantEl.textContent.trim() : '',
        price: priceEl ? priceEl.textContent.trim() : '',
        currentQty: currentQty,
        maxQty: maxQty
      };
      
      if (maxQty <= 0) {
        itemsToMove.push(itemData);
        log('Found out of stock item:', itemData.title);
      } else if (currentQty > maxQty) {
        itemsToReduce.push(itemData);
        log('Found over stock item:', itemData.title, 'has', currentQty, 'but only', maxQty, 'available');
      }
    });
    
    if (itemsToMove.length === 0 && itemsToReduce.length === 0) {
      log('No stock issues in cartbox');
      return Promise.resolve();
    }
    
    // Process items sequentially
    var processQueue = [];
    
    // Handle items that need quantity reduction
    itemsToReduce.forEach(function(item) {
      processQueue.push(function() {
        log('Reducing quantity for', item.variantId, 'from', item.currentQty, 'to', item.maxQty);
        
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            line: parseInt(item.line, 10),
            quantity: item.maxQty
          })
        }).then(function() {
          showStockNotification('"' + item.title + '" quantity reduced to ' + item.maxQty + ' (max available)');
        });
      });
    });
    
    // Handle completely out of stock items
    itemsToMove.forEach(function(item) {
      processQueue.push(function() {
        // Add to saved list with outOfStock flag
        var payload = {
          variantId: item.variantId,
          title: item.title,
          url: item.url,
          image: item.image,
          variant_title: item.variant_title,
          price: item.price,
          quantity: item.currentQty,
          outOfStock: true
        };
        
        var vid = String(payload.variantId);
        window.VC_SAVED = window.VC_SAVED || [];
        
        var existingIndex = window.VC_SAVED.findIndex(function(i) {
          return String(i.variantId || i.variant_id) === vid;
        });
        
        if (existingIndex !== -1) {
          window.VC_SAVED[existingIndex].quantity = 
            (window.VC_SAVED[existingIndex].quantity || 0) + payload.quantity;
          window.VC_SAVED[existingIndex].outOfStock = true;
        } else {
          window.VC_SAVED.unshift(payload);
        }
        
        // Remove from cart
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            line: parseInt(item.line, 10),
            quantity: 0
          })
        }).then(function() {
          log('Removed out of stock item from cart:', item.variantId);
          showStockNotification('"' + item.title + '" moved to Out of Stock - currently unavailable');
        });
      });
    });
    
    // Execute queue sequentially
    return processQueue.reduce(function(promise, fn) {
      return promise.then(fn);
    }, Promise.resolve()).then(function() {
      // Sync saved items to server
      if (typeof window.vcSyncSavedToServer === 'function') {
        return window.vcSyncSavedToServer();
      }
    }).then(function() {
      // Refresh cartbox and update UI
      return refreshCartbox();
    }).then(function() {
      return fetch('/cart.js', { credentials: 'same-origin' });
    }).then(function(r) {
      return r.json();
    }).then(function(cart) {
      refreshCartUI(cart);
      updateVisibility(cart);
      
      // Update saved list
      if (typeof window.VC_renderSavedList === 'function') {
        window.VC_renderSavedList();
      }
    }).catch(function(err) {
      console.error('[vc-cartbox] stock check error', err);
    });
  }

  /* =========================
     Event Listeners
     ========================= */
  
  // Cart updated externally - refresh cartbox and render saved list
  document.addEventListener('vc:cart:updated', function(e) {
    log('vc:cart:updated event received', e.detail);
    refreshCartbox().then(function() {
      log('refreshCartbox completed');
      if (e.detail) {
        updateVisibility(e.detail);
      }
      // Check for stock issues after refresh
      checkAndHandleStockIssues();
    });
  });
  
  // Listen for add to cart events
  document.addEventListener('cart:updated', function(e) {
    log('cart:updated event received', e.detail);
    refreshCartbox().then(function() {
      if (e.detail) {
        updateVisibility(e.detail);
      }
      // Check for stock issues after refresh
      checkAndHandleStockIssues();
    });
  });

  // Initialize on DOM ready
  function init() {
    bindCartChangeHandlers();

    // Render saved list if function exists
    if (typeof window.VC_renderSavedList === 'function') {
      window.VC_renderSavedList();
    }
    
    // Check for stock issues on initial load
    checkAndHandleStockIssues();
    
    log('Initialized - visibility set by Liquid');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
